<!-- 顶部 !-->
<template>
  <div class="topdiv">
    <div id="bars">
      <div class="content">
        <div class="centerBox">
          <div class="topMenu">
            <logo></logo>
            <search></search>
            <TopMenuItem></TopMenuItem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "./Logo.vue";
import search from "./search.vue";
import TopMenuItem from "./TopMenuItem.vue";

export default {
  components: {
    logo: Logo,
    search: search,
    TopMenuItem: TopMenuItem,
  },
};
</script>

<style scoped lang="scss">
.topdiv {
  width: 100%;
  height: 112px;
  background-color: #ffffff;
}
#bars {
  width: 1200px;
  height: 112px;
  background-color: #ffffff;
  margin: 0 auto;
}
#bars .content {
  width: 1200px;
  height: 30px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
.centerBox {
  height: 100%;
  width: 1200px;
  background-color: #ffffff;
}
.topMenu {
  display: flex;
  margin-top: 30px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
}
</style>
